import StormReportsAPI from "../../api/stormReports";
export const actions = {
  fetch: async (_, accountId) => {
    const { data } = await StormReportsAPI.get(accountId);
    return data;
  },
};
export default { namespaced: true, actions };
